import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskedLines } from "./Reveal";

const ABOUT_IMAGE = "/images/about-vedic.jpg";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="relative lg:col-span-5">
            <div className="hero-arch relative mx-auto aspect-[4/5] w-full max-w-md overflow-hidden">
              <motion.img
                style={{ y }}
                src={ABOUT_IMAGE}
                alt="Vedic Jyotish celestial chart diagram with concentric nakshatra orbits on warm cream parchment"
                className="h-[115%] w-full object-cover object-center opacity-90 mix-blend-multiply brightness-[0.98] contrast-[1.02]"
              />
            </div>
            <div className="pointer-events-none absolute -left-3 -top-3 h-full w-full rounded-t-[999px] border border-terracotta/35" />
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <p className="overline mb-6">{a.overline}</p>
            </Reveal>
            <h2 className="heading-serif whitespace-pre-line text-4xl leading-[1.02] tracking-tight text-forest sm:text-5xl lg:text-6xl">
              <MaskedLines lines={a.title.split("\n")} trigger="load" />
            </h2>

            <div className="mt-8 space-y-5">
              {a.body.map((para, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <p className="body-text max-w-xl">{para}</p>
                </Reveal>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4 border-t border-line pt-8">
              {a.stats.map((s, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <div>
                    <span className="heading-serif block text-3xl text-terracotta md:text-4xl">
                      {s.value}
                    </span>
                    <span className="mt-1 block text-xs tracking-wide text-ink-soft md:text-sm">
                      {s.label}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
